/**
 * 홈 상단 "학습통계" 파란 박스. StatisticsCard 3칸(오늘 완료 / 전체 완료 문제 / 전체 완료 챕터)을 나란히 둔다.
 * MyStatics 가 useGetLearningStatistics 응답을 그대로 내려준다.
 *
 * ★ isTodaySolved prop 은 받기만 하고 실제로 쓰지 않는다(구조 분해에서 빠져 있음).
 * 코드를 그대로 두라는 지시에 따라 고치지 않고 사실만 남긴다.
 */
import React from "react";
import StatisticsCard from "./StatisticsCard";
import { useTrialBlock } from "@/hooks/useTrialBlock";

interface LearningStatisticsProps {
  isTodaySolved: boolean;
  completedAnswerCount: number;
  questionCount: number;
  chapterCount: number;
}

/** 학습통계 3칸 카드. 세 칸 모두 클릭하면 (실제 이동이 아니라) 체험용 계정 접근 제한 모달을 연다. */
const LearningStatistics: React.FC<LearningStatisticsProps> = ({
  completedAnswerCount,
  questionCount,
  chapterCount,
}) => {
  // 체험용 계정: 통계 카드 클릭 시 이동 대신 접근 제한 모달
  const openTrialBlock = useTrialBlock();

  return (
    <div className="bg-primary-muted rounded-[20px] p-[24px] cursor-pointer">
      <div className="text-18 text-heading font-bold mb-[24px] font-heading">학습통계</div>

      <div className="flex justify-between">
        <StatisticsCard
          title="완료한"
          sub="오늘의 문제"
          value={completedAnswerCount}
          onClick={() => openTrialBlock("학습통계")}
        />
        <StatisticsCard
          title="지금까지"
          sub="완료한 문제"
          value={questionCount}
          onClick={() => openTrialBlock("학습통계")}
        />
        <StatisticsCard
          title="지금까지"
          sub="완료한 챕터"
          value={chapterCount}
          onClick={() => openTrialBlock("학습통계")}
        />
      </div>
    </div>
  );
};

export default LearningStatistics;
